import React, { useCallback, useMemo, useState } from 'react'
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import LinkComponent from './LinkComponent';
import FooterColumnComponent from './FooterColumnComponent';
import LogoSvg from '../svg/LogoSvg';
import SelectComponent from './SelectComponent';
import SocialsGroupComponent from './SocialsGroupComponent';
import { useSelector } from 'react-redux';
import AComponent from './AComponent';
import { RAMI_PLAY_STORE, RAMI_APP_STORE, RAMIRENT_URL, SOFINE } from '../constants';
import AppStoreSvg from '../svg/AppStoreSvg';
import PlayStoreSvg from '../svg/PlayStoreSvg';
import RouteLinkComponent from './RouteLinkComponent';
//import ReactGA from 'react-ga';
import moment from 'moment';
import preloadPages from '../functions/preloadPages';
import { ROUTES } from '../constants/routes';
import { gaEventPush } from '../functions/ga';
// import ReactGA from 'react-ga';

const useStyles = (disableFoot, disableMargin) => makeStyles((theme) => ({
    footer: {
        marginTop: disableFoot || disableMargin ? 0 : 80,
        [theme.breakpoints.down('sm')]: {
            marginTop: disableFoot || disableMargin ? 0 : 40,
            paddingBottom: disableFoot ? 0 : 55,
        }
    },
    container: {
        background: theme.palette.secondary.main,
        paddingTop: 40,
        [theme.breakpoints.down('xs')]: {
            paddingTop: 20,
        }
    },
    containerCopyright: {
        padding: '20px 0',
        background: theme.palette.primary.main,
        [theme.breakpoints.down('xs')]: {
            padding: '5px 0',
        }
    },
    linksContainer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        }
    },
    link: {
        margin: 10,
        marginLeft: 0,
        fontSize: 14,
        color: 'white',
    },
    copyrights: {
        margin: 10,
        marginRight: 0,
        fontSize: 14,
        color: 'white',
        opacity: 0.3,
        textAlign: 'right',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            margin: 0,
            marginBottom: 10,
        }
    },
    shopLinks: {
        display: 'block'
    },
    icon: {
        height: 25,
        width: 'auto'
    },
    slogan: {
        fontSize: 15,
        textTransform: 'uppercase',
        marginTop: 10,
    },
    address: {
        marginTop: 20,
        fontSize: 14,
        color: theme.palette.primary.main,
        [theme.breakpoints.down('xs')]: {
            marginTop: 30,
        }
    },
    phoneEmail: {
        fontSize: 16,
        color: theme.palette.primary.main,
    },
    phoneEmailBox: {
        paddingTop: theme.spacing(2),
    },
    titleCont: {
        [theme.breakpoints.down('md')]: {
            padding: '20px 0',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '10px 0',
        },
    },
    googlePlay: {
        maxWidth: 135,
    },
    selecter: {
        '& button': {
            boxShadow: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    customRootClass: {
        background: `${theme.palette.primary.main} !important`,
        color: theme.palette.white.main,
        padding: '16px 20px  !important',
        border: 'none !important',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'left',
            width: '100%',
        },
    },

    gridCont: {
        [theme.breakpoints.down('sm')]: {
            margin: 'auto',
            width: '100%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
    },
    gridContCopyrights: {
        [theme.breakpoints.down('xs')]: {
            margin: 'auto',
            width: '100%'
        },
    },
    cert: {
        width: 180,
        height: 180,
        marginRight: 20,
        marginTop: 10,
        objectFit: 'contain',
        [theme.breakpoints.down('sm')]: {
            width: 150,
            height: 150,
        },
    },
    certBox: {
        marginTop: 10,
        paddingBottom: 20,
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
    },
}))

const FooterComponent = ({ disableLargeFooter, disableMargin }) => {
    const classes = useStyles(disableLargeFooter, disableMargin)();
    const { t } = useTranslation();
    const countries = useMemo(() =>
        t('footer.countries_select',
            { returnObjects: true })
        , [t])
    const [country, setCountry] = useState('PL');
    const menu = useSelector(state => state.ContainerReducer.menu?.footer_menu);
    const bottomMenu = useSelector(state => state.ContainerReducer.menu?.bottom_menu);
    const certificaties = useSelector(state => state.ContainerReducer.menu?.certificaties);

    const handleCountry = useCallback((e) => {
        const url = countries.find((item, index) => index === e);
        if (url) {
            window.open(url.value, '_blank');
        }
    }, [countries])

    const handleGA = useCallback((store) => {
        gaEventPush('Social', `${t('ga.shop')} ${store}`)
    }, [t])

    const handlePreloadPages = useCallback(() => {
        preloadPages();
    }, [])
    return (
        <Box component='footer' className={classes.footer}>
            {disableLargeFooter
                ? ''
                : <Box className={classes.container}>
                    <Container >
                        <Grid container spacing={1} className={classes.gridCont}>
                            <Grid item md={3} xs={12} >
                                <Box className={classes.titleCont}>
                                    <LogoSvg className={classes.icon} />
                                    <Typography
                                        className={classes.slogan}
                                        variant='body1'
                                        color='primary'
                                    >
                                        {t('footer.slogan')}
                                    </Typography>
                                    <AComponent
                                        fontSize={16}
                                        href={`http://maps.google.com/maps?q=${t("footer.google_address")}`}
                                        title={t(`footer.address`)}
                                        typClass={classes.address}
                                    />
                                    <Box className={classes.phoneEmailBox}>
                                        <LinkComponent
                                            extrLink
                                            title={t("footer.phone")}
                                            href={"tel:0800123687"}
                                            className={classes.phoneEmail}
                                        />
                                        <LinkComponent
                                            extrLink
                                            title={t("footer.email")}
                                            href={`mailto:${t("footer.email")}`}
                                            className={classes.phoneEmail}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item md={9} xs={12} onMouseOver={handlePreloadPages}>
                                <Grid container >
                                    <FooterColumnComponent
                                        lg={3}
                                        xs={12}
                                        key='branches'
                                        slug={RAMIRENT_URL}
                                        externalLink
                                        title={t('footer.branches_col_title')}
                                    >
                                        <SelectComponent
                                            fullWidth
                                            customClass={classes.selecter}
                                            customRootClass={classes.customRootClass}
                                            name='country'
                                            id='countrySelect'
                                            title={t('footer.country_select')}
                                            value={country}
                                            onChange={handleCountry}
                                            data={countries?.length ? countries.map((c, index) => ({
                                                value: index,
                                                title: c.title
                                            })) : []}
                                            setValue={setCountry}
                                        />
                                    </FooterColumnComponent>
                                    {menu?.length
                                        ? menu.map((item) =>
                                            <FooterColumnComponent
                                                key={item.id}
                                                title={item.name}
                                                externalLink={item.external_link}
                                                pageLink={item.page_link}
                                                anchor={item.anchor}
                                                slug={item.slug}
                                                links={item.children}
                                            />)
                                        : ''}
                                    <FooterColumnComponent
                                        key='app'
                                        title={t('footer.app_col_title')}
                                        slug={ROUTES['app_landing']}
                                        slash=''
                                        lg={3}
                                    >
                                        <a href={RAMI_APP_STORE} onClick={() => handleGA('App Store')} className={classes.shopLinks} title={t('appstore')} target="_blank" rel="noopener noreferrer">
                                            <AppStoreSvg className={classes.googlePlay} />
                                        </a>
                                        <a href={RAMI_PLAY_STORE} onClick={() => handleGA('Google Play')} className={classes.shopLinks} title={t('google_play')} target="_blank" rel="noopener noreferrer">
                                            <PlayStoreSvg className={classes.googlePlay} />
                                        </a>
                                    </FooterColumnComponent>
                                </Grid>
                            </Grid>
                        </Grid>
                            {certificaties?.length
                                ? <Box display='flex' flexWrap='wrap' className={classes.certBox}>
                                    {
                                        certificaties.map((c) => c?.file_url ?
                                            <RouteLinkComponent key={c.id} href={c.file_url} blank>
                                                <img src={c.icon} className={classes.cert} alt={c.name} width='180' height='150' />
                                            </RouteLinkComponent> : <img src={c.icon} key={c.id} className={classes.cert} alt={c.name} width='180' height='150' />
                                        )
                                    }
                                </Box>
                                : ''
                            }
                    </Container>
                </Box>
            }
            <Box className={classes.containerCopyright}>
                <Container>
                    <Grid container spacing={1} className={classes.gridContCopyrights}>
                        <Grid item md={8} sm={6} xs={12} className={classes.linksContainer}>
                            {bottomMenu?.length
                                ? bottomMenu.map((item) =>
                                    <LinkComponent
                                        key={item.id}
                                        extrLink={item.external_link}
                                        title={item.name}
                                        href={item.slug}
                                        pageLink={item.page_link}
                                        className={classes.link}
                                    />
                                )
                                : ''}
                            <Box display='flex' alignItems='center'>
                                <Typography variant='body1' className={classes.link}>
                                    {t('footer.follow_us')}
                                </Typography>
                                <SocialsGroupComponent />
                            </Box>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <Typography variant='body1' className={classes.copyrights}>
                                {t('footer.copyright')}{moment().format('YYYY')} Ramirent
                            </Typography>
                            <Typography variant='body1' className={classes.copyrights}>
                                {t('footer.realization')} <RouteLinkComponent href={SOFINE} >SO FINE.agency</RouteLinkComponent>
                            </Typography>
                        </Grid>

                    </Grid>
                </Container>
            </Box>
        </Box>
    )
}


export default React.memo(FooterComponent);
